import axios from 'axios';
import {
  SET_LOADER,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_VENDOR_MENU_CATEGORY,
  GET_VENDOR_MENU_CATEGORY_ITEMS,
  GET_VENDOR_ALL_MENU_ITEMS,
  SET_ACTIVE_ITEM_ID_MENU_SETUP,
  GET_VENDOR_ADDED_TEMPLATES,
  GET_VENDOR_ADDED_TEMPLATES_ALL,
  GET_LOCAL_CATALOG_DATA,
  GET_LOCAL_ITEMS_DATA,
  SET_MENU_LOADER,
  CLEAR_MENU_LOADER,
  SET_ACTIVE_ITEM_ID_MENU_SETUP_DATA,
} from '../../types';

import { setErrors } from '../../actions/errorActions';
import { serverApi } from '../../../config/Keys';
import isEmpty from '../../validation/is-Empty';
import Alert from 'react-s-alert';

/***************************************
 * @DESC - GET CATEGORY MENU SETUP ACTION
 *****************************************/
export const get_category_menu_setup =
  (token, onSuccess, noLoader) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({
      type: GET_VENDOR_MENU_CATEGORY,
      payload: [],
    });
    if (!noLoader) {
      dispatch({ type: SET_LOADER });
    }

    try {
      let get_category_menu_setup = await axios.get(
        `${serverApi}/menu-category`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (get_category_menu_setup.status === 200) {
        dispatch({
          type: GET_VENDOR_MENU_CATEGORY,
          payload: get_category_menu_setup.data,
        });
        onSuccess(get_category_menu_setup.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_category_menu_setup_with_loader =
  (token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({
      type: GET_VENDOR_MENU_CATEGORY,
      payload: [],
    });
    dispatch({ type: SET_MENU_LOADER });
    try {
      let get_category_menu_setup = await axios.get(
        `${serverApi}/menu-category`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (get_category_menu_setup.status === 200) {
        dispatch({
          type: GET_VENDOR_MENU_CATEGORY,
          payload: get_category_menu_setup.data,
        });
        onSuccess(get_category_menu_setup.data);
        dispatch({ type: CLEAR_MENU_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_MENU_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_category_menu_setup_without_loader =
  (token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });

    try {
      let get_category_menu_setup = await axios.get(
        `${serverApi}/menu-category`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (get_category_menu_setup.status === 200) {
        dispatch({
          type: GET_VENDOR_MENU_CATEGORY,
          payload: get_category_menu_setup.data,
        });
        onSuccess(get_category_menu_setup.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const create_new_item_menu_setup =
  (formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let add_new_item_menu_setup = await axios.post(
        `${serverApi}/vendor-items`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      // console.log(add_new_item_menu_setup.data, 'dataaaa');
      if (add_new_item_menu_setup.status === 201) {
        dispatch({
          type: SET_ACTIVE_ITEM_ID_MENU_SETUP,
          payload: add_new_item_menu_setup.data._id,
        });
        dispatch({
          type: SET_ACTIVE_ITEM_ID_MENU_SETUP_DATA,
          payload: formData,
        });
        dispatch({
          type: GET_VENDOR_MENU_CATEGORY_ITEMS,
          payload: add_new_item_menu_setup.data,
        });
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
      }
    } catch (err) {
      if (err !== undefined) {
        onError(err.response);
      }
      dispatch(setErrors(err));
      dispatch({ type: CLEAR_LOADER });
    }
  };

export const update_item_menu_setup =
  (itemId, formData, token, onSuccess, noLoader) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    if (!noLoader) dispatch({ type: SET_LOADER });

    try {
      let update_new_item_menu_setup = await axios.patch(
        `${serverApi}/vendor-items/${itemId}`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (update_new_item_menu_setup.status === 200) {
        dispatch({
          type: GET_VENDOR_MENU_CATEGORY_ITEMS,
          payload: update_new_item_menu_setup.data,
        });
        onSuccess(update_new_item_menu_setup.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError(err);
    }
  };

export const get_item_details_from_item_id =
  (itemId, token) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_item_from_category = await axios.get(
        `${serverApi}/vendor-items/${itemId}`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (get_item_from_category.status === 200) {
        dispatch({
          type: GET_VENDOR_MENU_CATEGORY_ITEMS,
          payload: get_item_from_category.data,
        });

        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const delete_item_from_category =
  (itemId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_item_from_category = await axios.delete(
        `${serverApi}/vendor-items/${itemId}`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (get_item_from_category.status === 200) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const all_get_vendor_added_templates =
  (vendorId, token) => async (dispatch) => {
    //dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });
    try {
      let get_added_templates = await axios.get(
        `${serverApi}/item/templates?vendor_id=${vendorId}`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (get_added_templates.status === 200) {
        dispatch({
          type: GET_VENDOR_ADDED_TEMPLATES_ALL,
          payload: get_added_templates.data,
        });
        //dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_vendor_added_templates =
  (vendorId, token) => async (dispatch) => {
    //dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });

    try {
      let get_added_templates = await axios.get(
        `${serverApi}/templates?vendor_id=${vendorId}`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (get_added_templates.status === 200) {
        dispatch({
          type: GET_VENDOR_ADDED_TEMPLATES,
          payload: get_added_templates.data.data,
        });

        //dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const add_new_template_vendor =
  (formData, token, onSuccess, msg, onUpdateFormik) => async (dispatch) => {
    //dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });

    try {
      let add_new_template_vendor = await axios.post(
        `${serverApi}/templates`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (add_new_template_vendor.status === 201) {
        onSuccess(msg);
        onUpdateFormik(add_new_template_vendor.data);
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const add_new_choice_template_vendor =
  (templateId, formData, token, onSuccess, msg, onUpdateFormik) =>
  async (dispatch) => {
    //dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });
    try {
      let add_new_choice_template_vendor = await axios.patch(
        `${serverApi}/templates/${templateId}`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (add_new_choice_template_vendor.status === 200) {
        onSuccess(msg);
        onUpdateFormik(add_new_choice_template_vendor.data);
        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const delete_vendor_template =
  (templateId, token, onSuccess) => async (dispatch) => {
    //dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });

    try {
      let deleteVendorTemplate = await axios.delete(
        `${serverApi}/templates/${templateId}`,

        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (deleteVendorTemplate.status === 200) {
        onSuccess();

        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_menu_items = (token, onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  //dispatch({ type: SET_LOADER });

  try {
    let get_menu_items = await axios.get(`${serverApi}/vendor-items`, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    });
    if (get_menu_items.status === 200) {
      dispatch({
        type: GET_VENDOR_ALL_MENU_ITEMS,
        payload: get_menu_items.data,
      });
      if (onSuccess) onSuccess(get_menu_items.data);
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const reset_all_sold_out = (token, onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });

  try {
    let reset_all_sold_out = await axios.get(`${serverApi}/resetsoldout`, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    });
    if (reset_all_sold_out.status === 200) {
      onSuccess();
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const get_menu_items_by_passing_item_id_in_array =
  (token, formData, onSuccess, items, itemsArr) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });

    try {
      let get_menu_items_by_passing_item_id_in_array = await axios.post(
        `${serverApi}/vendor/items`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (get_menu_items_by_passing_item_id_in_array.status === 201) {
        onSuccess(
          get_menu_items_by_passing_item_id_in_array.data,
          items,
          itemsArr
        );
        dispatch({ type: CLEAR_LOADER });
      } else {
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_item_menu_setup_without_loader =
  (itemId, formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });

    try {
      let update_new_item_menu_setup = await axios.patch(
        `${serverApi}/vendor-items/${itemId}`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (update_new_item_menu_setup.status === 200) {
        onSuccess(formData);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_create_local_catalog_global =
  (token, chainCatalogId, onSuccessGetCategoryData) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let vendor_create_local_catalog_chain = await axios.get(
        `${serverApi}/vendor/localCategoryItems/${chainCatalogId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (vendor_create_local_catalog_chain.status === 200) {
        onSuccessGetCategoryData();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_create_local_catalog_chain =
  (token, chainCatalogId, onSuccessGetCategoryData) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let vendor_create_local_catalog_chain = await axios.get(
        `${serverApi}/vendor/localCategoryItems/${chainCatalogId}?chainCatalogue=true`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (vendor_create_local_catalog_chain.status === 200) {
        onSuccessGetCategoryData();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_show_local_menu_category =
  (token, vendorId, catalogId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let vendor_create_local_catalog_chain = await axios.get(
        `${serverApi}/menu-category?is_temp_local=true&vendor_id=${vendorId}&catalogue_id=${catalogId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (vendor_create_local_catalog_chain.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: GET_LOCAL_CATALOG_DATA,
          payload: vendor_create_local_catalog_chain.data,
        });
        onSuccess(vendor_create_local_catalog_chain.data);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_show_local_menu_items =
  (token, vendorId) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let vendor_show_local_menu_items = await axios.get(
        `${serverApi}/admin/items?is_temp_local=true&vendor_id=${vendorId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (vendor_show_local_menu_items.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: GET_LOCAL_ITEMS_DATA,
          payload: vendor_show_local_menu_items.data,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_copy_items_from_catalog =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let vendor_copy_items_from_catalog = await axios.post(
        `${serverApi}/vendor/localCategoryItems`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (vendor_copy_items_from_catalog.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

///fetch menu for petpooja menu //

export const fetch_menu_from_pos =
  (token, onSuccess, noLoader) => async (dispatch) => {
    try {
      let fetch_menu_from_pos = await axios.get(
        `${serverApi}/merchant/pos/fetchMenu`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (fetch_menu_from_pos.data.name === 'amealio-error') {
        Alert.error(`<h4>${fetch_menu_from_pos.data.message}</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else if (
        fetch_menu_from_pos.status === 200 &&
        fetch_menu_from_pos.data.name !== 'amealio-error'
      ) {
        Alert.success(`<h4>Menu fetched successfully</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
